<div class="history-main-wrapper">
    <!-- HEADER -->
    <header class="dash-header">
        <div class="head-left">
            <h1><mat-icon>assessment</mat-icon> Histórico de Notificaciones</h1>
            <p>Auditoría de envíos, métricas de dispositivos y rendimiento por plataforma.</p>
        </div>

        <div class="head-right">
            <div class="filter-range">
                <mat-form-field appearance="outline" class="compact-field">
                    <mat-label>Desde</mat-label>
                    <input matInput type="date" [(ngModel)]="desde" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="compact-field">
                    <mat-label>Hasta</mat-label>
                    <input matInput type="date" [(ngModel)]="hasta" />
                </mat-form-field>

                <button mat-flat-button class="btn-refresh" (click)="applyRange()" [disabled]="loading">
                    <mat-icon>refresh</mat-icon>
                    <span>ACTUALIZAR</span>
                </button>
            </div>
        </div>
    </header>

    <!-- KPI DASHBOARD -->
    <div class="kpi-dashboard">
        <div class="kpi-dashboard-grid">
            <div class="kpi-card">
                <div class="kpi-icon total"><mat-icon>send</mat-icon></div>
                <div class="kpi-content">
                    <span class="label">Total Envíos</span>
                    <span class="value">{{ totalPush | number }}</span>
                </div>
            </div>

            <div class="kpi-card ios">
                <div class="kpi-icon"><mat-icon>apple</mat-icon></div>
                <div class="kpi-content">
                    <span class="label">Mensajes iOS</span>
                    <span class="value">{{ totalIOS | number }}</span>
                </div>
            </div>

            <div class="kpi-card android">
                <div class="kpi-icon"><mat-icon>android</mat-icon></div>
                <div class="kpi-content">
                    <span class="label">Mensajes Android</span>
                    <span class="value">{{ totalAndroid | number }}</span>
                </div>
            </div>

            <div class="kpi-card users">
                <div class="kpi-icon"><mat-icon>group</mat-icon></div>
                <div class="kpi-content">
                    <span class="label">Auditoría Usuarios</span>
                    <span class="value">{{ usuariosInvolucrados | number }}</span>
                </div>
            </div>

            <div class="kpi-card devices clickable" (click)="openDevicesModal()">
                <div class="kpi-icon"><mat-icon>devices</mat-icon></div>
                <div class="kpi-content">
                    <span class="label">Dispositivos Activos</span>
                    <div class="value-complex">
                        <span class="main">{{ totalDevices | number }}</span>
                        <span class="sub">🍎 {{ totalDevicesIOS }} | 🤖 {{ totalDevicesAndroid }}</span>
                    </div>
                </div>
                <mat-icon class="arrow-indicator">chevron_right</mat-icon>
            </div>
        </div>
    </div>

    <!-- TABS PARA EL HISTÓRICO -->
    <mat-tab-group class="custom-tabs mt-3" animationDuration="0ms">
        <!-- SOLAPA 1: HISTORIAL PUSH GENERAL -->
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon style="margin-right: 8px;">history_toggle_off</mat-icon>
                Historial Push General
            </ng-template>
            <div style="padding-top: 15px;">
    <!-- MAIN CONTENT GRID -->
    <div class="dashboard-grid">
        <!-- LEFT: SEARCH & USER CONTEXT -->
        <div class="grid-col search-area">
            <mat-card class="content-card">
                <div class="card-header">
                    <mat-icon>search</mat-icon>
                    <h2>Buscador de Usuarios</h2>
                </div>
                
                <div class="card-body">
                    <mat-form-field appearance="outline" class="full-width search-field">
                        <mat-label>Nombre o email (min. 2 letras)</mat-label>
                        <input matInput [(ngModel)]="userQuery" (ngModelChange)="onSearchUsers()" placeholder="Ej: Juan Ramos..." />
                        <mat-icon matPrefix>person_search</mat-icon>
                        <button mat-icon-button matSuffix *ngIf="userQuery" (click)="userQuery = ''; userResults = []">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>

                    <!-- SEARCH RESULTS DROPDOWN-STYLE -->
                    <div class="search-results" *ngIf="userResults.length">
                        <div class="result-row" *ngFor="let u of userResults" (click)="openUserLogs(u)">
                            <div class="user-avatar">{{ u.nombrePersona?.charAt(0) }}{{ u.apellidoPersona?.charAt(0) }}</div>
                            <div class="user-info">
                                <div class="name">{{ u.nombrePersona }} {{ u.apellidoPersona }}</div>
                                <div class="email">{{ u.email }}</div>
                            </div>
                            <div class="user-meta">
                                <span class="badge">{{ u.pushCount }} push</span>
                                <mat-icon>chevron_right</mat-icon>
                            </div>
                        </div>
                    </div>

                    <!-- SELECTED USER DISPLAY -->
                    <div class="selected-user-panel" *ngIf="selectedUser">
                        <div class="user-header">
                            <div class="avatar-large">{{ selectedUser.nombrePersona?.charAt(0) }}{{ selectedUser.apellidoPersona?.charAt(0) }}</div>
                            <div class="details">
                                <h3>{{ selectedUser.nombrePersona }} {{ selectedUser.apellidoPersona }}</h3>
                                <span>{{ selectedUser.email }}</span>
                            </div>
                            <button mat-icon-button color="warn" (click)="clearUser()" matTooltip="Quitar selección">
                                <mat-icon>person_remove</mat-icon>
                            </button>
                        </div>
                        <div class="user-stats">
                            <div class="stat-item">
                                <span class="s-label">Total Push</span>
                                <span class="s-value">{{ selectedUser.pushCount || 0 }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card>

            <!-- CHART SECTION -->
            <mat-card class="content-card chart-card">
                <div class="card-header">
                    <mat-icon>show_chart</mat-icon>
                    <h2>Volumen Diario General</h2>
                </div>
                <div class="card-body chart-container">
                    <div class="chart-canvas-wrap" *ngIf="chartData?.datasets?.length">
                        <canvas baseChart [datasets]="chartData.datasets" [labels]="chartData.labels" [options]="chartOptions" [legend]="true" chartType="line"></canvas>
                    </div>
                    <div class="no-data" *ngIf="!chartData?.datasets?.length">No hay datos para el rango seleccionado</div>
                </div>
            </mat-card>
        </div>

        <!-- RIGHT: LOGS TABLE -->
        <div class="grid-col logs-area">
            <mat-card class="content-card logs-card">
                <div class="card-header justify-between">
                    <div class="title-group">
                        <mat-icon>history</mat-icon>
                        <h2>Historial de Mensajes</h2>
                        <span class="count-badge" *ngIf="selectedUser">{{ filteredLogs.length }}</span>
                    </div>
                    
                    <div class="header-actions" *ngIf="selectedUser && logs.length">
                        <mat-form-field appearance="outline" class="table-filter">
                            <input matInput [(ngModel)]="logFilter" placeholder="Filtrar por título..." />
                            <mat-icon matPrefix>filter_list</mat-icon>
                        </mat-form-field>
                    </div>
                </div>

                <div class="card-body table-container">
                    <div #logsSection></div>
                    <div class="table-scroll" *ngIf="logs.length; else emptyLogs">
                        <table mat-table [dataSource]="filteredLogs" class="modern-table">
                            <ng-container matColumnDef="fecha">
                                <th mat-header-cell *matHeaderCellDef>Fecha y Hora</th>
                                <td mat-cell *matCellDef="let l" class="date-cell">
                                    {{ l.created | date: "dd/MM/yyyy" }}
                                    <small>{{ l.created | date: "HH:mm" }}</small>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="device">
                                <th mat-header-cell *matHeaderCellDef>Plataforma</th>
                                <td mat-cell *matCellDef="let l">
                                    <span class="platform-chip" [ngClass]="l.device">
                                        <mat-icon>{{ l.device === "ios" ? "apple" : "android" }}</mat-icon>
                                        {{ l.device | uppercase }}
                                    </span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="titulo">
                                <th mat-header-cell *matHeaderCellDef>Título</th>
                                <td mat-cell *matCellDef="let l" class="title-cell">{{ l.titulo }}</td>
                            </ng-container>

                            <ng-container matColumnDef="mensaje">
                                <th mat-header-cell *matHeaderCellDef>Contenido del Mensaje</th>
                                <td mat-cell *matCellDef="let l" class="msg-cell">{{ l.mensaje }}</td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns" sticky></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                        </table>
                    </div>

                    <ng-template #emptyLogs>
                        <div class="empty-state">
                            <mat-icon>notifications_off</mat-icon>
                            <p>{{ selectedUser ? (logFilter ? 'No hay mensajes que coincidan con el filtro' : 'Sin mensajes para este periodo') : 'Seleccioná un usuario para ver su historial' }}</p>
                        </div>
                    </ng-template>
                </div>
            </mat-card>
        </div>
    </div>

            </div>
        </mat-tab>

        <!-- SOLAPA 2: COMUNICACIONES Y MENSAJES INTERNOS -->
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon style="margin-right: 8px;">campaign</mat-icon>
                Comunicaciones y Mensajes Internos
            </ng-template>
            <div style="padding-top: 15px; padding-bottom: 20px;">
                <!-- NUEVA SECCIÓN: Comunicaciones y Métricas (Centro de Notificaciones) -->
                <div class="notifications-section">
                    <mat-card class="content-card">
                        <div class="card-header justify-between" style="display: flex; align-items: center; padding: 15px 20px; border-bottom: 1px solid #eee;">
                            <div class="title-group" style="display: flex; align-items: center; gap: 8px;">
                                <mat-icon style="color: #8E1F3F;">campaign</mat-icon>
                                <div>
                                    <h2 style="margin: 0; font-size: 1.2rem; font-weight: bold; color: #333;">Comunicaciones Enviadas</h2>
                                    <p style="margin: 2px 0 0 0; font-size: 0.8rem; color: #666;">Historial y estadísticas de todos los envíos masivos e individuales en todo el sistema.</p>
                                </div>
                                <span class="count-badge" style="background-color: #8E1F3F; color: white; padding: 2px 8px; border-radius: 12px; font-size: 0.85rem; font-weight: bold;">{{ filteredNotificaciones.length }}</span>
                            </div>
                            <div style="margin-left: auto;">
                                <mat-checkbox [(ngModel)]="showDocNotifications" color="primary" style="font-size: 0.85rem; font-weight: 500;">
                                    Mostrar avisos de documentación
                                </mat-checkbox>
                            </div>
                        </div>

                        <div class="card-body" style="padding: 15px;">
                            <div style="display: grid; grid-template-columns: 3fr 2fr; gap: 20px;">
                                <!-- Tabla de notificaciones -->
                                <div style="border-right: 1px solid #eee; padding-right: 20px; max-height: 450px; overflow-y: auto;">
                                    <table class="modern-table" style="width: 100%; border-collapse: collapse;">
                                        <thead>
                                            <tr style="border-bottom: 2px solid #ddd; text-align: left; font-size: 0.85rem; color: #666;">
                                                <th style="padding: 10px 5px;">Fecha</th>
                                                <th style="padding: 10px 5px;">Título</th>
                                                <th style="padding: 10px 5px; text-align: right;">Total</th>
                                                <th style="padding: 10px 5px; text-align: right;">Con Push</th>
                                                <th style="padding: 10px 5px; text-align: right;">Sin Push</th>
                                                <th style="padding: 10px 5px; text-align: right;">Internos</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let n of filteredNotificaciones" (click)="selectNotification(n)" 
                                                [style.backgroundColor]="selectedNotificationDetail?._id === n._id ? '#f1f3f5' : 'transparent'"
                                                style="border-bottom: 1px solid #eee; cursor: pointer; transition: background 0.2s;" 
                                                onmouseover="this.style.backgroundColor='#f1f3f5'" 
                                                onmouseout="this.style.backgroundColor=this.getAttribute('style').includes('selectedNotificationDetail?._id') ? '#f1f3f5' : 'transparent'">
                                                <td style="padding: 10px 5px; font-size: 0.85rem;">{{ n.fechaEnvio || n.createdAt | date: "dd/MM/yyyy" }}</td>
                                                <td style="padding: 10px 5px; font-weight: 500; font-size: 0.85rem; max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ n.asunto }}</td>
                                                <td style="padding: 10px 5px; text-align: right; font-size: 0.85rem;">{{ n.metricas ? n.metricas.destinatarios : (n.destinatarios ? n.destinatarios.length : 0) }}</td>
                                                <td style="padding: 10px 5px; text-align: right; font-size: 0.85rem; color: #2e7d32;">{{ n.metricas ? n.metricas.conPush : 0 }}</td>
                                                <td style="padding: 10px 5px; text-align: right; font-size: 0.85rem; color: #c62828;">{{ n.metricas ? n.metricas.sinPush : 0 }}</td>
                                                <td style="padding: 10px 5px; text-align: right; font-size: 0.85rem; color: #ef6c00;">{{ n.metricas ? n.metricas.mensajesInternos : (n.destinatarios ? n.destinatarios.length : 0) }}</td>
                                            </tr>
                                            <tr *ngIf="filteredNotificaciones.length === 0">
                                                <td colspan="6" style="padding: 20px; text-align: center; color: #999;">No hay notificaciones enviadas en este rango de fechas.</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- Detalle de métricas -->
                                <div>
                                    <div *ngIf="selectedNotificationDetail" style="background-color: #fafafa; border: 1px solid #e9ecef; border-radius: 8px; padding: 15px; position: relative;">
                                        <button mat-icon-button (click)="closeNotificationDetail()" style="position: absolute; top: 10px; right: 10px;">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                        
                                        <h3 style="margin: 0 0 5px 0; color: #8E1F3F; font-size: 1.1rem; font-weight: bold; padding-right: 30px;">{{ selectedNotificationDetail.asunto }}</h3>
                                        <p style="margin: 0 0 15px 0; font-size: 0.85rem; color: #666; font-style: italic;">
                                            Enviado el: {{ selectedNotificationDetail.fechaEnvio || selectedNotificationDetail.createdAt | date: "dd/MM/yyyy HH:mm" }}
                                        </p>

                                        <div style="background-color: #fff; border: 1px solid #eee; border-radius: 6px; padding: 12px; margin-bottom: 12px;">
                                            <span style="font-size: 0.75rem; text-transform: uppercase; color: #888; font-weight: bold; display: block; margin-bottom: 2px;">Cuerpo del Mensaje</span>
                                            <p style="margin: 0; font-size: 0.9rem; color: #333; white-space: pre-wrap; word-break: break-word;">{{ selectedNotificationDetail.cuerpo }}</p>
                                        </div>

                                        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 15px;">
                                            <div style="background-color: #e3f2fd; border-radius: 6px; padding: 10px; text-align: center; cursor: pointer; border: 1px solid transparent; transition: all 0.2s;"
                                                 (click)="verDestinatarios(selectedNotificationDetail)"
                                                 onmouseover="this.style.borderColor='#1565c0'; this.style.backgroundColor='#e1f5fe'"
                                                 onmouseout="this.style.borderColor='transparent'; this.style.backgroundColor='#e3f2fd'"
                                                 matTooltip="Ver listado detallado de destinatarios">
                                                <span style="font-size: 0.8rem; color: #1565c0; font-weight: 500; display: flex; align-items: center; justify-content: center; gap: 4px; margin-bottom: 2px;">
                                                    Destinatarios Totales <mat-icon style="font-size: 0.95rem; width: auto; height: auto;">open_in_new</mat-icon>
                                                </span>
                                                <span style="font-size: 1.3rem; font-weight: bold; color: #0d47a1;">{{ selectedNotificationDetail.metricas ? selectedNotificationDetail.metricas.destinatarios : (selectedNotificationDetail.destinatarios ? selectedNotificationDetail.destinatarios.length : 0) }}</span>
                                            </div>
                                            <div style="background-color: #fff3e0; border-radius: 6px; padding: 10px; text-align: center;">
                                                <span style="font-size: 0.8rem; color: #e65100; font-weight: 500; display: block;">Mensajes Internos</span>
                                                <span style="font-size: 1.3rem; font-weight: bold; color: #e65100;">{{ selectedNotificationDetail.metricas ? selectedNotificationDetail.metricas.mensajesInternos : (selectedNotificationDetail.destinatarios ? selectedNotificationDetail.destinatarios.length : 0) }}</span>
                                            </div>
                                        </div>

                                        <!-- Desglose de Push -->
                                        <h4 style="margin: 0 0 8px 0; font-size: 0.9rem; font-weight: bold; text-transform: uppercase; color: #555; border-bottom: 1px solid #eee; padding-bottom: 4px;">Push</h4>
                                        <div style="margin-bottom: 15px; font-size: 0.85rem;">
                                            <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
                                                <span>Con token:</span>
                                                <strong>{{ selectedNotificationDetail.metricas ? selectedNotificationDetail.metricas.conPush : 0 }}</strong>
                                            </div>
                                            <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
                                                <span>Push intentados:</span>
                                                <strong>{{ selectedNotificationDetail.metricas ? selectedNotificationDetail.metricas.pushIntentados : 0 }}</strong>
                                            </div>
                                            <div style="display: flex; justify-content: space-between; margin-bottom: 4px; color: #2e7d32;">
                                                <span>Push enviados correctamente:</span>
                                                <strong>{{ selectedNotificationDetail.metricas ? selectedNotificationDetail.metricas.pushCorrectos : 0 }}</strong>
                                            </div>
                                            <div style="display: flex; justify-content: space-between; margin-bottom: 4px; color: #c62828;">
                                                <span>Push con error:</span>
                                                <strong>{{ selectedNotificationDetail.metricas ? selectedNotificationDetail.metricas.pushError : 0 }}</strong>
                                            </div>
                                        </div>

                                        <!-- Desglose Sin Push -->
                                        <h4 style="margin: 0 0 8px 0; font-size: 0.9rem; font-weight: bold; text-transform: uppercase; color: #555; border-bottom: 1px solid #eee; padding-bottom: 4px;">Sin Push</h4>
                                        <div style="margin-bottom: 15px; font-size: 0.85rem;">
                                            <div style="display: flex; justify-content: space-between;">
                                                <span>Usuarios sin token:</span>
                                                <strong>{{ selectedNotificationDetail.metricas ? selectedNotificationDetail.metricas.sinPush : 0 }}</strong>
                                            </div>
                                        </div>

                                        <!-- Desglose Mensajes Internos (Lectura Dinámica) -->
                                        <h4 style="margin: 0 0 8px 0; font-size: 0.9rem; font-weight: bold; text-transform: uppercase; color: #555; border-bottom: 1px solid #eee; padding-bottom: 4px;">Mensajes internos (Lectura)</h4>
                                        <div style="font-size: 0.85rem;">
                                            <div style="display: flex; justify-content: space-between; margin-bottom: 4px; color: #2e7d32;">
                                                <span>Leídos:</span>
                                                <strong>{{ selectedNotificationDetail.leidos }}</strong>
                                            </div>
                                            <div style="display: flex; justify-content: space-between; margin-bottom: 8px; color: #d84315;">
                                                <span>No leídos:</span>
                                                <strong>{{ selectedNotificationDetail.noLeidos }}</strong>
                                            </div>
                                            
                                            <!-- Progreso de lectura -->
                                            <div style="margin-top: 10px;">
                                                <div style="display: flex; justify-content: space-between; margin-bottom: 2px;">
                                                    <span>Lectura de mensaje interno</span>
                                                    <strong>{{ ((selectedNotificationDetail.leidos / (selectedNotificationDetail.metricas ? selectedNotificationDetail.metricas.mensajesInternos : (selectedNotificationDetail.destinatarios ? selectedNotificationDetail.destinatarios.length : 1) || 1)) * 100) | number:'1.0-0' }}%</strong>
                                                </div>
                                                <div style="width: 100%; background-color: #eee; height: 12px; border-radius: 6px; overflow: hidden; display: flex;">
                                                    <div [style.width.%]="(selectedNotificationDetail.leidos / (selectedNotificationDetail.metricas ? selectedNotificationDetail.metricas.mensajesInternos : (selectedNotificationDetail.destinatarios ? selectedNotificationDetail.destinatarios.length : 1) || 1)) * 100" style="background-color: #2e7d32; height: 100%;"></div>
                                                </div>
                                                <span style="font-size: 0.75rem; color: #666; margin-top: 4px; display: block;">
                                                    {{ selectedNotificationDetail.leidos }} de {{ selectedNotificationDetail.metricas ? selectedNotificationDetail.metricas.mensajesInternos : (selectedNotificationDetail.destinatarios ? selectedNotificationDetail.destinatarios.length : 0) }} usuarios leyeron el mensaje
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div *ngIf="!selectedNotificationDetail" style="border: 2px dashed #eee; border-radius: 8px; height: 100%; min-height: 250px; display: flex; align-items: center; justify-content: center; color: #999; padding: 20px; text-align: center;">
                                        <div>
                                            <mat-icon style="font-size: 2.5rem; width: auto; height: auto;">insert_chart</mat-icon>
                                            <p style="margin: 10px 0 0 0; font-size: 0.9rem;">Seleccioná una notificación de la lista para ver el desglose de métricas detallado.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-card>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>

    
<!-- MODAL: DETALLE DE DESTINATARIOS -->
<ng-template #recipientsModal>
    <div style="padding: 20px; display: flex; flex-direction: column; min-height: 350px;">
        <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #eee; padding-bottom: 15px; margin-bottom: 15px;">
            <h2 style="margin: 0; font-size: 1.25rem; color: #8E1F3F; font-weight: bold; display: flex; align-items: center; gap: 8px;">
                <mat-icon>group</mat-icon> Destinatarios de la Comunicación
            </h2>
            <button mat-icon-button mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <!-- Spinner de carga -->
        <div *ngIf="loadingDestinatarios" style="display: flex; flex-direction: column; align-items: center; justify-content: center; flex-grow: 1; padding: 40px 0;">
            <mat-spinner diameter="45" style="margin-bottom: 15px;"></mat-spinner>
            <span style="color: #666; font-size: 0.95rem;">Cargando destinatarios y estados de lectura...</span>
        </div>

        <div *ngIf="!loadingDestinatarios" style="flex-grow: 1;">
            <div style="margin-bottom: 12px; font-size: 0.9rem; color: #555;">
                Mostrando los <strong>{{ destinatariosDetalle.length }}</strong> destinatarios de la notificación.
            </div>

            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #e0e0e0; border-radius: 6px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 0.9rem;">
                    <thead>
                        <tr style="background-color: #f8f9fa; border-bottom: 1px solid #e0e0e0; text-align: left;">
                            <th style="padding: 10px 15px; font-weight: 500; color: #555;">Nombre</th>
                            <th style="padding: 10px 15px; font-weight: 500; color: #555;">Email</th>
                            <th style="padding: 10px 15px; font-weight: 500; color: #555; text-align: center;">Push</th>
                            <th style="padding: 10px 15px; font-weight: 500; color: #555; text-align: center;">Mensaje Interno</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let u of destinatariosDetalle" style="border-bottom: 1px solid #eee;">
                            <td style="padding: 8px 15px;">{{ u.nombre }}</td>
                            <td style="padding: 8px 15px; color: #666;">{{ u.email }}</td>
                            <td style="padding: 8px 15px; text-align: center;">
                                <span *ngIf="u.hasPush" style="background-color: #e8f5e9; color: #2e7d32; padding: 2px 8px; border-radius: 12px; font-size: 0.75rem; font-weight: 500; display: inline-flex; align-items: center; gap: 4px;">
                                    <mat-icon style="font-size: 0.85rem; width: auto; height: auto;">check</mat-icon> Habilitado
                                </span>
                                <span *ngIf="!u.hasPush" style="background-color: #fafafa; color: #999; padding: 2px 8px; border-radius: 12px; font-size: 0.75rem; font-weight: 500;">
                                    Sin token
                                </span>
                            </td>
                            <td style="padding: 8px 15px; text-align: center;">
                                <span *ngIf="u.leido" style="background-color: #e3f2fd; color: #0d47a1; padding: 2px 8px; border-radius: 12px; font-size: 0.75rem; font-weight: 500; display: inline-flex; align-items: center; gap: 4px;">
                                    <mat-icon style="font-size: 0.85rem; width: auto; height: auto;">visibility</mat-icon> Leído
                                </span>
                                <span *ngIf="!u.leido" style="background-color: #fff3e0; color: #e65100; padding: 2px 8px; border-radius: 12px; font-size: 0.75rem; font-weight: 500; display: inline-flex; align-items: center; gap: 4px;">
                                    <mat-icon style="font-size: 0.85rem; width: auto; height: auto;">visibility_off</mat-icon> No leído
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div style="display: flex; justify-content: flex-end; margin-top: 15px; border-top: 1px solid #eee; padding-top: 15px;">
            <button mat-button mat-dialog-close color="primary">Cerrar</button>
        </div>
    </div>
</ng-template>

<!-- LOADING OVERLAY -->
    <div class="loading-overlay" *ngIf="loading">
        <mat-card class="loader-card">
            <mat-spinner diameter="40"></mat-spinner>
            <div class="loader-info">
                <strong>{{ loadingText || "Cargando" }}</strong>
                <span>Por favor aguardá un momento...</span>
            </div>
        </mat-card>
    </div>
</div>
